module.exports = __webpack_public_path__ + "img/photo.60f0926c.svg";